<template>
  <div class="supportbot-page">

   <transition name="fade-slide">
      <div v-if="isLoading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>
    <!-- === FILTER ROW === -->
    <div class="filter-row"
         style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap;
                gap:12px; margin:0 .5rem 1.5rem .5rem; animation: fadeIn 0.4s ease;">
      <h1 style="display:flex; align-items:center; gap:8px; font-size:1.2rem; font-weight:700; color:var(--text); margin:0;">
        <i class="bx bx-bot" style="font-size:1.4rem; color:var(--primary);"></i>
        Chatbot Overview
      </h1>

      <div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
        <select v-model="selectedWebsite"
                style="padding:8px 12px; border:1px solid var(--border); border-radius:6px;
                       background:var(--card); color:var(--text); font-size:13px; min-width:160px;">
          <option disabled value="">-- Select Website --</option>
          <option v-for="web in websites" :key="web.website_id" :value="web.website_domain">
            {{ web.website_domain }}
          </option>
        </select>

        <select v-model="selectedStatus"
                style="padding:8px 12px; border:1px solid var(--border); border-radius:6px;
                       background:var(--card); color:var(--text); font-size:13px; min-width:140px;">
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button @click="applyFilters"
                style="display:inline-flex; align-items:center; gap:6px; background:var(--primary);
                       color:#fff; border:none; border-radius:6px; padding:8px 16px;
                       font-size:13px; font-weight:600; cursor:pointer; transition:all 0.3s ease;">
          <i class="bx bx-search"></i> Apply
        </button>

        <button @click="creWebNow"
                style="display:inline-flex; align-items:center; gap:6px; background:var(--primary);
                       color:#fff; border:none; border-radius:6px; padding:8px 16px;
                       font-size:13px; font-weight:600; cursor:pointer; transition:all 0.3s ease;">
          <i class="bx bx-plus"></i> Add New
        </button>
      </div>
    </div>

    <!-- === KPI ROW === -->
    <div class="kpi-row" style="display:flex; flex-wrap:wrap; gap:20px; margin-bottom:24px;">
      <div v-for="card in botStats" :key="card.title"
           class="kpi-card"
           style="flex:1; min-width:220px; background:var(--card); border:1px solid var(--border);
                  border-radius:var(--radius); padding:16px 20px; display:flex;
                  justify-content:space-between; align-items:center; box-shadow:0 2px 6px rgba(0,0,0,0.05);
                  transition:all 0.3s ease;">
        <div>
          <h4 style="margin:0; font-size:14px; color:var(--muted); font-weight:500;">{{ card.title }}</h4>
          <div style="font-size:1.4rem; font-weight:700; color:var(--text);">{{ card.value }}</div>
        </div>
        <i :class="card.icon" style="font-size:1.6rem; color:var(--primary); opacity:0.9;"></i>
      </div>
    </div>

    <!-- === BOT CARDS GRID === -->
    <div v-if="!isLoading && bots.length > 0" class="bot-grid"
         style="display:flex; flex-wrap:wrap; gap:20px; justify-content:flex-start; animation:fadeIn 0.4s ease;">
      <div v-for="bot in paginatedBots" :key="bot.website_id"
           class="bot-card"
           style="flex:0 0 calc(33.333% - 20px); background:var(--card); border:1px solid var(--border);
                  border-radius:var(--radius); box-shadow:0 2px 6px rgba(0,0,0,0.05); padding:16px;
                  display:flex; flex-direction:column; justify-content:space-between; transition:all 0.3s ease; min-width:260px;">

        <!-- === Card Header === -->
        <div>
          <div style="display:flex; align-items:center; justify-content:space-between;">
            <div style="display:flex; align-items:center; gap:8px;">
              <div class="bot-logo"
                   :style="{ background: bot.website_chatbot_color || '#f3f4f6' }"
                   style="width:32px; height:32px; border-radius:8px; display:flex; align-items:center; justify-content:center;">
                <img :src="bot.website_chatbot_avtar || 'https://cdn-icons-png.flaticon.com/512/4712/4712070.png'" 
                     alt="logo" style="width:20px; height:20px; object-fit:contain;" />
              </div>
              <h4 style="margin:0; font-size:1rem; color:var(--text); font-weight:600;">
                {{ bot.website_chatbot_name || 'Unnamed Bot' }}
              </h4>
            </div>
            <span :class="'status ' + (bot.website_chatbot_status || 'inactive').toLowerCase()"
                  style="padding:4px 10px; border-radius:6px; font-size:0.8rem; font-weight:600;">
              {{ bot.website_chatbot_status || 'Inactive' }}
            </span>
          </div>

          <!-- === Bot Description === -->
          <p style="margin-top:8px; font-size:13px; color:var(--muted); line-height:1.5;">
            {{ bot.website_chatbot_msg || 'No description available.' }}
          </p>
        </div>

        <!-- === Branding Info Section === -->
        <div style="margin-top:12px;">
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <span style="font-size:12px; color:var(--muted);">Website: 
              <strong style="color:var(--primary);">{{ bot.website_domain || 'N/A' }}</strong>
            </span>
          </div>
        </div>

        <!-- === Footer Actions === -->
        <div class="bot-footer"
             style="display:flex; justify-content:space-between; align-items:center; margin-top:14px;">
          <span style="font-size:12px; color:var(--muted);">Updated: {{ bot.website_datetime || 'N/A' }}</span>
          <div style="display:flex; gap:8px;">
            <button @click="editBot(bot)" class="btn-edit">
              <i class="bx bx-edit-alt"></i> Edit
            </button>
            <button @click="handleDelete(bot)" class="btn-delete">
              <i class="bx bx-trash"></i> Delete
            </button>
          </div>
        </div>
      </div>
    </div>

   
      <div v-else-if="!isLoading && bots.length === 0" class="empty-state">
        <i class="bx bx-bot"></i>
        <h3>No Bots Found</h3>
        <p>To add Chatbot, Please create website. if not created</p>
        <button
          class="btn-primary"
          @click="creWebNow"
          style="padding: 8px 14px; font-size: 13px; border-radius: 6px;"
        >
          <i class="bx bx-plus" style="font-size: 14px; color: white; margin-top: .7rem;"></i> Create New Website
        </button>
      </div>

    <!-- === PAGINATION === -->
    <div v-if="bots.length > 0"
         style="display:flex; justify-content:space-between; align-items:center; margin-top:24px; flex-wrap:wrap; gap:10px;">
      <span style="font-size:13px; color:var(--muted);">
        Showing {{ startIndex + 1 }}–{{ endIndex }} of {{ filteredBots.length }} bots
      </span>
      <div style="display:flex; align-items:center; gap:6px;">
        <button @click="prevPage" :disabled="currentPage === 1"
                style="border:none; background:#F3F4F6; color:var(--text); padding:6px 10px;
                       border-radius:6px; cursor:pointer;">
          <i class='bx bx-chevron-left'></i>
        </button>
        <button style="border:none; background:var(--primary); color:#fff; padding:6px 12px;
                       border-radius:6px; font-weight:600;">{{ currentPage }}</button>
        <button @click="nextPage" :disabled="endIndex >= filteredBots.length"
                style="border:none; background:#F3F4F6; color:var(--text); padding:6px 10px;
                       border-radius:6px; cursor:pointer;">
          <i class='bx bx-chevron-right'></i>
        </button>
      </div>
    </div>

    <!-- === CREATE / EDIT BOT MODAL === -->
    <div v-if="showCreateModal" class="modal-overlay">
      <div class="modal-content">
        <h3 style="margin-bottom:14px; color:var(--text); font-size:1.1rem; font-weight:700;">
          <i class="bx bx-bot" style="color:var(--primary); font-size:1.3rem; margin-right:6px;"></i>
          {{ isEditing ? "Update Chatbot" : "Create New Chatbot " }}
        </h3>

        <div class="modal-body">
          <label>Website</label>
          <select v-model="newBot.website_id">
            <option disabled value="">-- Select Website --</option>
            <option v-for="web in websites" :key="web.website_id" :value="web.website_id">
              {{ web.website_domain }}
            </option>
          </select>

          <label>Bot Icon</label>
          <input type="file" accept="image/*" @change="onIconChange" />
          <div v-if="newBot.iconPreview" class="icon-preview">
            <img :src="newBot.iconPreview" alt="Bot Icon" />
          </div>

          <label>Brand Color</label>
          <input type="color" v-model="newBot.color" style="height:38px;" />

          <label>Bot Name</label>
          <input type="text" v-model="newBot.name" placeholder="Enter bot name..." />

          <label>Welcome Message</label>
          <textarea v-model="newBot.message" placeholder="Type welcome message..." rows="3"></textarea>

          <label>Training Data File (PDF / DOCX)</label>
          <input type="file" accept=".pdf,.doc,.docx" @change="onFileUpload" />
          <div v-if="newBot.fileName" class="file-preview">
            <i class="bx bx-file" style="color:var(--primary); font-size:1rem;"></i>
            <span>{{ newBot.fileName }}</span>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="cancelCreate" class="btn-cancel">Cancel</button>
          <button @click="createBot" class="btn-create">{{ isEditing ? "Update Bot" : "Create Bot" }}</button>
        </div>
      </div>
    </div>

    <!-- === ALERT / CONFIRMATION MODAL === -->
<div v-if="alertBox.show" class="alert-overlay">
  <div class="alert-content" :class="alertBox.type">
    <i :class="alertIcon" class="alert-icon"></i>
    <h4 class="alert-title">{{ alertBox.title }}</h4>
    <p class="alert-message">{{ alertBox.message }}</p>

    <div class="alert-actions">
      <button v-if="alertBox.type === 'confirm'" @click="confirmAction" class="btn-confirm">
        Yes, Continue
      </button>
      <button @click="closeAlert" class="btn-close">
        {{ alertBox.type === 'confirm' ? 'Cancel' : 'Close' }}
      </button>
    </div>
  </div>
</div>

  </div>
</template>


<script scoped>
import { getBots, getBotReport, createBot, deleteBot } from "@/apis/supbotapis";
import { getWebsites } from "@/apis/webapis";
import { useToast } from "vue-toastification";

export default {
  name: "SupportBotPage",

  data() {
    return {
      alertBox: {
        show: false,
        type: "info", // info | success | error | confirm
        title: "",
        message: "",
        callback: null,
      },
      isLoading: false,
      showCreateModal: false,
      websites: [],
      newBot: {
        website_id: "",
        iconFile: null,
        iconPreview: "",
        color: "#111827",
        name: "",
        message: "",
        trainingFile: null,
        fileName: "",
      },
      selectedWebsite: "",
      selectedStatus: "All Status",
      currentPage: 1,
      perPage: 6,
      bots: [],
      user_id: JSON.parse(sessionStorage.getItem("ldata") || "{}").user_id || "",
      isEditing: false,
      editingBotId: null,
    };
  },

  computed: {
    alertIcon() {
    switch (this.alertBox.type) {
      case "success": return "bx bx-check-circle";
      case "error": return "bx bx-error-circle";
      case "confirm": return "bx bx-help-circle";
      default: return "bx bx-info-circle";
    }
  },
    filteredBots() {
      let data = this.bots;
      if (this.selectedWebsite)
        data = data.filter((b) =>
          b.website_domain?.toLowerCase().includes(this.selectedWebsite.toLowerCase())
        );
      if (this.selectedStatus !== "All Status") {
        const status = this.selectedStatus.toLowerCase();
        data = data.filter((b) => b.website_chatbot_status === status);
      }
      return data;
    },
    paginatedBots() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredBots.slice(start, start + this.perPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.perPage, this.filteredBots.length);
    },
    botStats() {
      const total = this.bots.length;
      const active = this.bots.filter((b) => b.website_chatbot_status === "active").length;
      const deactive = this.bots.filter((b) => b.website_chatbot_status === "inactive").length;
      return [
        { title: "Total Bots", value: total, icon: "bx bx-bot" },
        { title: "Active Bots", value: active, icon: "bx bx-check-circle" },
        { title: "Deactive Bots", value: deactive, icon: "bx bx-power-off" },
      ];
    },
  },

  methods: {
    creWebNow(){
      if(this.websites.length>0){
        this.openCreateModal();
      }
      else{
        window.location.href = "/new_website";
      }
    },
    showAlert({ type = "info", title = "", message = "", callback = null }) {
    this.alertBox = { show: true, type, title, message, callback };
  },
  closeAlert() {
    this.alertBox.show = false;
  },
  confirmAction() {
    if (this.alertBox.callback) this.alertBox.callback();
    this.closeAlert();
  },
    async fetchWebsites() {
      try {
        const res = await getWebsites(this.user_id, "none");
        if (res.status && res.records) this.websites = res.records;
      } catch (e) {
        console.error("Websites fetch failed", e);
      }
    },

    async fetchBots() {
      const toast = useToast();
      try {
        this.isLoading = true;
        const res = await getBots(this.user_id, this.currentPage - 1);
        if (res.status && res.records) {
          this.bots = res.records;
        } else {
          this.bots = [];
          toast.warning("No bots found");
        }
      } catch (e) {
        toast.error("Failed to fetch bots");
      } finally {
        this.isLoading = false;
      }
    },

    async fetchBotReport() {
      try {
        const res = await getBotReport(this.user_id);
        if (res.status) {
          this.botStats = [
            { title: "Total Bots", value: res.total_bots, icon: "bx bx-bot" },
            { title: "Active Bots", value: res.active_bots, icon: "bx bx-check-circle" },
            { title: "Deactive Bots", value: res.deactive_bots, icon: "bx bx-power-off" },
          ];
        }
      } catch (e) {
        console.error("Bot report error", e);
      }
    },
async handleDelete(bot) {
  // Show confirmation alert instead of native confirm()
  this.showAlert({
    type: "confirm",
    title: "Confirm Delete",
    message: `Are you sure you want to delete the bot "${bot.website_chatbot_name}"?`,
    callback: async () => {
      // const toast = useToast();
      this.isLoading = true;

      try {
        const res = await deleteBot(bot.website_id);

        if (res.status) {
          this.showAlert({
            type: "success",
            title: "Bot Deleted",
            message: "The chatbot has been successfully deleted.",
          });

          this.fetchBots();
          this.fetchBotReport();
        } else {
          this.showAlert({
            type: "error",
            title: "Delete Failed",
            message: res.success || "Unable to delete bot. Please try again.",
          });
        }
      } catch (error) {
        this.showAlert({
          type: "error",
          title: "Error Occurred",
          message: "Something went wrong while deleting the bot.",
        });
      } finally {
        this.isLoading = false;
      }
    },
  });
}
,

    openCreateModal() {
      this.showCreateModal = true;
      this.isEditing = false;
      this.resetForm();
    },

    editBot(bot) {
      this.showCreateModal = true;
      this.isEditing = true;
      this.newBot = {
        website_id: bot.website_id,
        color: bot.website_chatbot_color,
        name: bot.website_chatbot_name,
        message: bot.website_chatbot_msg,
        iconPreview: bot.website_chatbot_avtar,
        iconFile: null,
        trainingFile: null,
        fileName: "",
      };
      this.editingBotId = bot.website_id;
    },

    cancelCreate() {
      this.showCreateModal = false;
      this.resetForm();
    },

    resetForm() {
      this.newBot = {
        website_id: "",
        iconFile: null,
        iconPreview: "",
        color: "#111827",
        name: "",
        message: "",
        trainingFile: null,
        fileName: "",
      };
    },

    onIconChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.newBot.iconFile = file;
        this.newBot.iconPreview = URL.createObjectURL(file);
      }
    },

    onFileUpload(e) {
      const file = e.target.files[0];
      if (file) {
        this.newBot.trainingFile = file;
        this.newBot.fileName = file.name;
      }
    },

    async createBot() {
      const toast = useToast();
      if (!this.newBot.website_id) {
        toast.warning("Website is required");
        return;
      }

      if (!this.newBot.name) {
        toast.warning("Bot name is required");
        return;
      }

      try {
        this.isLoading = true;
        const res = await createBot(
          this.newBot.website_id,
          this.newBot.name,
          "active",
          this.newBot.color,
          this.newBot.iconFile,
          this.newBot.message,
          this.newBot.trainingFile
        );
        if (res.status) {
          toast.success(this.isEditing ? "Bot updated successfully" : "Bot created successfully");
          this.showCreateModal = false;
          await this.fetchBots();
          await this.fetchBotReport();
        } else {
          toast.error(res.success || "Failed to save bot");
        }
      } catch (e) {
        toast.error("Error while saving bot");
      } finally {
        this.isLoading = false;
      }
    },

    async applyFilters() {
      this.currentPage = 1;
      await this.fetchBots();
      await this.fetchBotReport();
    },

    nextPage() {
      if (this.endIndex < this.filteredBots.length) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },

  async mounted() {
    await this.fetchWebsites();
    await this.fetchBotReport();
    await this.fetchBots();
  },
};
</script>
<style scoped>
/* === ALERT MODAL === */
.alert-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(4px);
  z-index: 5000;
  animation: fadeIn 0.3s ease;
}

.alert-content {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px 24px;
  max-width: 380px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  animation: popIn 0.25s ease;
}

.alert-icon {
  font-size: 2.2rem;
  margin-bottom: 8px;
}

.alert-title {
  margin: 0;
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--text);
}

.alert-message {
  color: var(--muted);
  font-size: 14px;
  margin: 6px 0 14px 0;
  line-height: 1.4;
}

/* === Alert Type Colors === */
.alert-content.success .alert-icon { color: #16A34A; }
.alert-content.error .alert-icon { color: #DC2626; }
.alert-content.confirm .alert-icon { color: var(--primary); }
.alert-content.info .alert-icon { color: var(--primary); }

/* === Buttons === */
.alert-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn-confirm,
.btn-close {
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.btn-confirm {
  background: var(--primary);
  color: #fff;
}

.btn-confirm:hover {
  opacity: 0.9;
}

.btn-close {
  background: #f3f4f6;
  color: var(--text);
}

.btn-close:hover {
  background: #e5e7eb;
}

/* === LOADER OVERLAY === */
.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(3px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease;
}

.loader-overlay p {
  margin-top: 12px;
  font-size: 14px;
  color: var(--muted);
  font-weight: 500;
}

.spinner {
  width: 42px;
  height: 42px;
  border: 4px solid var(--border);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* === PLACEHOLDER STYLE (when no bots) === */
.placeholder-box {
  text-align: center;
  padding: 60px 20px;
  color: var(--muted);
  background: var(--card);
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.placeholder-box i {
  font-size: 3rem;
  color: var(--primary);
  opacity: 0.8;
}

.placeholder-box p {
  margin-top: 10px;
  font-size: 14px;
  color: var(--muted);
}

/* === SMOOTH MODAL ANIMATION === */
.modal-content {
  transform: scale(0.95);
  animation: popIn 0.3s ease forwards;
}

@keyframes popIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* === Slight Hover Glow for KPI Cards === */
.kpi-card:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  transform: translateY(-3px);
}

/* === TRUE SCREEN-CENTER MODAL === */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: all;
  overflow: hidden; /* ensures full-screen overlay */
}

/* === Centered Modal Box (Always in Screen Center) === */
.modal-content {
  position: fixed;
  top: 40%;
  left: 40%;
  transform: translate(-50%, -50%);
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 480px;
  padding: 24px 28px;
  animation: zoomIn 0.25s ease-out;
  z-index: 10000;
}

/* === Prevent Background Scroll === */
body.modal-open {
  overflow: hidden !important;
}

/* === Animations === */
@keyframes zoomIn {
  from {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

.modal-body label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
  color: var(--muted);
}

.modal-body input,
.modal-body select,
.modal-body textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  color: var(--text);
  background: var(--card);
  outline: none;
  transition: border 0.3s ease;
}

.modal-body input:focus,
.modal-body select:focus,
.modal-body textarea:focus {
  border-color: var(--primary);
}

.icon-preview img {
  width: 50px;
  height: 50px;
  margin-top: 6px;
  border-radius: 8px;
  border: 1px solid var(--border);
  object-fit: cover;
}

.file-preview {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 13px;
  color: var(--text);
}

/* === Modal Footer === */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.btn-cancel,
.btn-create {
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-cancel {
  background: #f3f4f6;
  color: var(--text);
}

.btn-cancel:hover {
  background: #e5e7eb;
}

.btn-create {
  background: var(--primary);
  color: #fff;
}

.btn-create:hover {
  opacity: 0.9;
}

.bot-card {
  transition: all 0.3s ease;
}
.bot-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0,0,0,0.08);
}
.status.active {
  background: #DCFCE7;
  color: #166534;
}
.status.deactive {
  background: #FEE2E2;
  color: #991B1B;
}
@media (max-width: 992px) {
  .bot-card { flex: 0 0 calc(50% - 20px); }
}
@media (max-width: 600px) {
  .bot-card { flex: 0 0 100%; }
}
/* === Action Buttons === */
.btn-edit,
.btn-delete {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-edit {
  background: #EEF2FF;
  color: var(--primary);
}
.btn-edit:hover {
  background: var(--primary);
  color: #fff;
}

.btn-delete {
  background: #FEE2E2;
  color: #991B1B;
}
.btn-delete:hover {
  background: #DC2626;
  color: #fff;
}

/* Hover Animation for Card */
.bot-card {
  transition: all 0.3s ease;
}
.bot-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

/* Status Colors */
.status.active {
  background: #DCFCE7;
  color: #166534;
}
.status.deactive {
  background: #FEE2E2;
  color: #991B1B;
}

/* Responsive */
@media (max-width: 992px) {
  .bot-card { flex: 0 0 calc(50% - 20px); }
}
@media (max-width: 600px) {
  .bot-card { flex: 0 0 100%; }
}
/* =====================================================
   📱 RESPONSIVE FIX — SUPPORT BOT PAGE
   ===================================================== */

@media (max-width: 1024px) {
  .filter-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
    margin: 0 0.5rem 1.2rem 0.5rem !important;
  }

  .filter-row h1 {
    font-size: 1.1rem !important;
  }

  .filter-row div {
    width: 100% !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .filter-row select,
  .filter-row button {
    flex: 1 1 48% !important;
    min-width: 150px !important;
    font-size: 13px !important;
    padding: 8px 10px !important;
  }

  .kpi-row {
    gap: 16px !important;
    margin-bottom: 18px !important;
  }

  .kpi-card {
    min-width: 100% !important;
    padding: 14px 16px !important;
  }

  .bot-grid {
    justify-content: center !important;
  }

  .bot-card {
    flex: 0 0 calc(50% - 12px) !important;
    min-width: 260px !important;
    padding: 14px !important;
  }
}

@media (max-width: 768px) {
  .filter-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
    margin: 0 0.5rem 1rem 0.5rem !important;
  }

  .filter-row select,
  .filter-row button {
    width: 100% !important;
  }

  .kpi-row {
    flex-direction: column !important;
    gap: 14px !important;
  }

  .kpi-card {
    padding: 12px 14px !important;
  }

  .bot-grid {
    gap: 14px !important;
    justify-content: center !important;
  }

  .bot-card {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 14px !important;
    margin: 0 auto !important;
  }

  .bot-card h4 {
    font-size: 0.95rem !important;
  }

  .bot-card p {
    font-size: 12.5px !important;
  }

  .bot-footer {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .supportbot-page > div:last-child {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
    margin-top: 18px !important;
  }

  .supportbot-page {
    padding-bottom: 2.5rem !important;
  }
}

@media (max-width: 480px) {
  .filter-row h1 {
    font-size: 1rem !important;
  }

  .filter-row select,
  .filter-row button {
    font-size: 12px !important;
    padding: 6px 10px !important;
  }

  .kpi-card {
    padding: 10px 12px !important;
  }

  .bot-card {
    padding: 12px !important;
  }

  .bot-card p {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  .bot-footer button {
    padding: 5px 8px !important;
    font-size: 11px !important;
  }

  .supportbot-page {
    padding-bottom: 2rem !important;
  }
}
</style>
